import React from "react";
import { faExclamationCircle, faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";

const WarningInfoModal = ({ show, onHide, children }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Body
        style={{
          borderTop: "5px solid #f94f50",
        }}
      >
        <div className="d-flex">
          <div className="pr-3">
            <FontAwesomeIcon
              icon={faExclamationCircle}
              color="#f94f50"
              size="3x"
            />
          </div>
          <div>{children}</div>
          <div className="close-buttonWarningModal text-right">
            <FontAwesomeIcon
              icon={faTimes}
              color="#000"
              onClick={onHide}
              size="1x"
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default WarningInfoModal;
